import * as React from 'react';
import { Box, Text, Heading } from '@chakra-ui/react';

interface IProps {
  title: string;
  children: React.ReactNode;
  subtitle?: React.ReactNode;
}

const CardContainer = (props: IProps) => {
  const { title, children, subtitle } = props;

  return (
    <Box mb={10}>
      <Heading as="h2" fontSize="2xl" mb={3}>
        {title}
      </Heading>

      {subtitle ? (
        <Text color="muted" mb={4}>
          {subtitle}
        </Text>
      ) : null}

      {children}
    </Box>
  );
};

export { CardContainer };
